import React from 'react';
import { FullEventDisplay } from '../components/better/fullEventDisplay';
import { MoreWaysFooter } from '../components/moreWaysFooter';

export function ViewEvent() {
  return (
    <>
      <FullEventDisplay />
      <MoreWaysFooter dark />
    </>
  );
}
